// extracted by mini-css-extract-plugin
export var buttons = "bh_cr";
export var container = "bh_b";
export var image = "bh_g";
export var innerText = "bh_fv";
export var logo = "bh_br";
export var p = "bh_fs";
export var section = "bh_d";
export var short = "bh_ft";
export var tall = "bh_fw";
export var textContainer = "bh_cW";